"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var amazon_config_store_type_script_client_1 = require("@amzn/amazon-config-store-type-script-client");
var I18nPointsFormatContext = /** @class */ (function () {
    function I18nPointsFormatContext(i18nPointsformatLocale, i18nPointsProgramName, i18nPointsStyle) {
        this._i18nPointsformatLocale = i18nPointsformatLocale;
        this._i18nPointsProgramName = i18nPointsProgramName;
        this._i18nPointsStyle = i18nPointsStyle;
    }
    I18nPointsFormatContext.prototype.toRawContext = function () {
        var context = new Map();
        context.set("i18n_pointsformat_locale", this._i18nPointsformatLocale);
        context.set("i18n_points_program_name", this._i18nPointsProgramName);
        context.set("i18n_points_style", this._i18nPointsStyle);
        return new amazon_config_store_type_script_client_1.QueryContext(context);
    };
    Object.defineProperty(I18nPointsFormatContext.prototype, "i18nPointsformatLocale", {
        get: function () {
            return this._i18nPointsformatLocale;
        },
        set: function (value) {
            this._i18nPointsformatLocale = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(I18nPointsFormatContext.prototype, "i18nPointsProgramName", {
        get: function () {
            return this._i18nPointsProgramName;
        },
        set: function (value) {
            this._i18nPointsProgramName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(I18nPointsFormatContext.prototype, "i18nPointsStyle", {
        get: function () {
            return this._i18nPointsStyle;
        },
        set: function (value) {
            this._i18nPointsStyle = value;
        },
        enumerable: false,
        configurable: true
    });
    return I18nPointsFormatContext;
}());
exports.default = I18nPointsFormatContext;
